var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component case-city-chart"},[_c('common-title',{attrs:{"title":"案件分布"}}),_c('ve-map',{attrs:{"height":"450px","legend-visible":false,"data":_vm.caseCityChart.data,"settings":_vm.caseCityChart.setting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }